import { LoadStatus } from '@servicetitan/cp-ui';
import { inject, injectable } from '@servicetitan/react-ioc';
import { action, makeObservable, observable, runInAction } from 'mobx';
import {
    EstimateContainerWebModel,
    ProposalStatus,
    EstimateStatus,
} from '../api/portal-estimates.api';
import { ProposalsApi } from '../api/proposal-api';

export interface EstimateContainerModelDetails extends EstimateContainerWebModel {
    status: ProposalStatus;
}

@injectable()
export class EstimateContainerStore {
    @observable status = LoadStatus.None;
    @observable item?: EstimateContainerModelDetails;

    constructor(@inject(ProposalsApi) private proposalApi: ProposalsApi) {
        makeObservable(this);
    }

    @action init(estimateContainerId?: string) {
        if (!estimateContainerId) {
            this.status = LoadStatus.Error;
        } else if (estimateContainerId !== this.item?.id) {
            this.loadProposal(estimateContainerId).catch(() => null);
        } else {
            this.status = LoadStatus.Ok;
        }
    }

    private loadProposal = async (proposalId: string) => {
        runInAction(() => (this.status = LoadStatus.Loading));

        try {
            this.item = undefined;
            const item = await this.proposalApi.getEstimateContainer(proposalId);
            if (!item) {
                runInAction(() => (this.status = LoadStatus.Error));
                return;
            }
            runInAction(() => {
                this.item = {
                    ...item,
                    status: item.estimates.some(e => e.status === EstimateStatus.Sold)
                        ? ProposalStatus.Accepted
                        : ProposalStatus.Open,
                };
                this.status = LoadStatus.Ok;
            });
        } catch {
            runInAction(() => (this.status = LoadStatus.Error));
        }
    };
}
